/* eslint-disable */
import OrderEntityPropTypes from '../../Services/Order/Order.service.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderSummaryPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The remaining duration for the `accessToken`
   */
  summary: OrderEntityPropTypes.summary,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderSummaryPropTypes;
